import React from 'react'

/**
 * Same API as React.useReducer but first arg is key to the value in local storage
 *
 * @param {*} key
 * @param {*} initialValue
 */
export default function useLocalStorageReducer(key, reducer, initialValue, init) {
  // State to store our value
  return React.useReducer(
    (...args) => {
      try {
        // get new value
        const value = reducer(...args)

        // Save to local storage
        window.localStorage.setItem(key, JSON.stringify(value))

        // return value to store
        return value
      } catch (error) {
        // A more advanced implementation would handle the error case
        console.log(error)
      }
    },
    initialValue,
    initialValue => {
      const initialized = init ? init(initialValue) : initialValue
      try {
        // Get from local storage by key
        const item = window.localStorage.getItem(key)
        // Parse stored json or if none return initialized
        return item ? JSON.parse(item) : initialized
      } catch (error) {
        // If error also return initialized
        console.log(error)
        return initialized
      }
    }
  )
}
